// extracted by mini-css-extract-plugin
export var contentSection = "_9-8";
export var imageSection = "_9-1";
export var productGrid = "_9-0";
export var productImage = "_9-3";
export var productImageContainer = "_9-2";
export var productInfo = "_9-9";
export var purchaseControls = "_9-a";
export var quantityInput = "_9-c";
export var selectedThumbnail = "_9-6";
export var thumbnailContainer = "_9-4";
export var thumbnailImage = "_9-7";
export var thumbnailItem = "_9-5";
export var variantSelect = "_9-b";